import { render, staticRenderFns } from "./applyMembership.vue?vue&type=template&id=61b65a06&scoped=true"
import script from "./applyMembership.vue?vue&type=script&lang=js"
export * from "./applyMembership.vue?vue&type=script&lang=js"
import style0 from "./applyMembership.vue?vue&type=style&index=0&id=61b65a06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b65a06",
  null
  
)

export default component.exports